// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./ErrorBoundary.bs.js";

function ReusableReactSuspense(props) {
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  return React.createElement(ErrorBoundary$OrcaPaymentPage.make, {
              children: React.createElement(React.Suspense, {
                    children: Caml_option.some(props.children),
                    fallback: Caml_option.some(props.loaderComponent)
                  }),
              level: "PaymentMethod",
              componentName: props.componentName,
              publishableKey: match.publishableKey
            });
}

var make = ReusableReactSuspense;

export {
  make ,
}
/* jotai Not a pure module */
